import { Routes } from '@angular/router';

import { CMS_PERMISSIONS } from '../../core/constants/permissions';
import { permissionGuard } from '../../core/guards/permission.guard';

export const categoryRoutes: Routes = [
  {
    path: 'categorias',
    canActivate: [permissionGuard],
    data: {
      permission: CMS_PERMISSIONS.categories.viewAny,
    },
    loadComponent: () => import('./pages/table/table').then((m) => m.CategoriesTable),
  },
  {
    path: 'categorias/crear',
    canActivate: [permissionGuard],
    data: {
      permission: CMS_PERMISSIONS.categories.create,
    },
    loadComponent: () => import('./pages/form/form').then((m) => m.CategoriesForm),
  },
  {
    path: 'categorias/:id/editar',
    canActivate: [permissionGuard],
    data: {
      permission: CMS_PERMISSIONS.categories.update,
    },
    loadComponent: () => import('./pages/form/form').then((m) => m.CategoriesForm),
  },
];
